module.exports = __webpack_public_path__ + "b876922d82704bb0ebd72fb578f4b79e.pdf";